import * as React from 'react';
import { flattenDeep } from 'lodash';

import endpoints from 'src/common/config/endpoints';
import { useGet } from 'src/utils/hooks/useGet';

import { useInviteContext } from './useInviteContext';
import { IProgram } from 'src/common/models/program';

const { useMemo } = React;

export const useAllPrograms = () => {
  const {
    apiEndpoint,
    clientId,
  } = useInviteContext();

  const fetchAllProgramsUrl = useMemo(() => (
    apiEndpoint && clientId 
      ? `${apiEndpoint}/${endpoints.allProgramsEndpoint}?client_id=${clientId}`
      : undefined
  ), [apiEndpoint, clientId]);

  const {
    loading: isFetching,
    data: fetchedPrograms,
    error,
  } = useGet({ url: fetchAllProgramsUrl });

  const allPrograms: IProgram[] = useMemo(() => (
    flattenDeep(fetchedPrograms)
  ), [fetchedPrograms]);

  return {
    allPrograms: Object.freeze(allPrograms),
    isFetching,
    error
  };
};
